import navbar from "./navbar";
import layout from "./layout";
import auth from "./authentication";
import todo from "@src/views/apps/todo/store";
import chat from "@src/views/apps/chat/store";
import email from "@src/views/apps/email/store";
import kanban from "@src/views/apps/kanban/store";
import calendar from "@src/views/apps/calendar/store";
import ecommerce from "@src/views/apps/ecommerce/store";
import dataTables from "@src/views/tables/data-tables/store";
import permissions from "@src/views/apps/roles-permissions/store";
import app from "./app";
import dashboard from "./dashboard";
import product from "./product";
import productsClient from "./productClients";
import productsRelatory from "./productsRelatory";
import invoice from "./invoice";
import repricing from "./repricing";
import oportunidade from "./oportunidade";
import cest from "./cest";
import ncm from "./ncm";
import stores from "./stores";
import upload from "./Upload";
import users from "./users";
import accessGroups from "./accessGroups";
import dialogAlert from "./DialogAlert/dialog";
import alertness from "./alertness";
import storeStatus from "./Stores/status";
import taxAnalises from "./taxAnalises";
import internoListaClientes from "./interno/lista-clientes";
import storesForms from "./Stores/storesForms";
import fiscalDiagnosisProject from "./fiscalDiagnosis/project";
import relatorioSkus from "./relatorioSkus";
import relatorioCfopCsts from "./relatorioCfop";
import relatorioDocumentosFiscais from "./Relatorio/documentosFiscais";
import politicPrice from "./politicScreen";
import classificar from "./classificar";
import integrations from "./integrations";
import speds from "./speds";
import integrationsConfigs from "./integrations/configs";
import integrationSolicitation from "./integrations/solicitar";
import appEscrituracao from "./EscrituracaoFiscal/appEscrituracao";
import escrituracaoFiscalList from "./EscrituracaoFiscal/list";
import escrituracaoAssociation from "./EscrituracaoFiscal/association";
import escrituracaoAssociationNotesPendentes from "./EscrituracaoFiscal/association-notas-pendentes";
import parameterConfigurator from "./EscrituracaoFiscal/parameterConfigurator";
import escriturationClassification from "./EscrituracaoFiscal/classification";
import modules from "./modules";
import tagsXmls from "./tagsXmls";
import marketplace from "./marketplace/marketplace";
import robot from "./Suporte/Robot/robot";
import resend from "./reenvios";
import actionsNotes from "./EscrituracaoFiscal/actionsNote";
import atualizacoes from "./atualizacoes";
import produtoEanGtin from "./productEanGtin";
import painelCmf from "./Suporte/painel/painel";
import reportsEscrituration from "./EscrituracaoFiscal/reports";
import escrituracaoDash from "./EscrituracaoFiscal/escrituracaoDash";
import heatMap from "./heatMap";
import notificationAll from "./configs/notifications";

const rootReducer = {
  auth,
  todo,
  cest,
  chat,
  email,
  users,
  kanban,
  navbar,
  layout,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  app,
  dashboard,
  product,
  productsClient,
  invoice,
  repricing,
  oportunidade,
  upload,
  users,
  ncm,
  accessGroups,
  stores,
  dialogAlert,
  alertness,
  storeStatus,
  productsRelatory,
  taxAnalises,
  internoListaClientes,
  storesForms,
  fiscalDiagnosisProject,
  relatorioSkus,
  relatorioCfopCsts,
  relatorioDocumentosFiscais,
  politicPrice,
  classificar,
  integrations,
  speds,
  integrationsConfigs,
  integrationSolicitation,
  escrituracaoFiscalList,
  escrituracaoAssociation,
  appEscrituracao,
  escrituracaoAssociationNotesPendentes,
  parameterConfigurator,
  escriturationClassification,
  modules,
  tagsXmls,
  marketplace,
  robot,
  resend,
  actionsNotes,
  atualizacoes,
  produtoEanGtin,
  painelCmf,
  reportsEscrituration,
  escrituracaoDash,
  heatMap,
  notificationAll,
};

export default rootReducer;
